<template>
  <div class="telegram-auth-container">
    <div class="auth-content">
      <h2>Вход через Telegram</h2>
      <p>Для доступа к приложению необходимо авторизоваться через Telegram</p>
      <div id="telegram-login-widget" ref="loginWidget"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {onMounted, onUnmounted, ref} from 'vue'
import {useTelegramStore} from '@/stores/telegram'

const loginWidget = ref<HTMLElement>()
const telegramStore = useTelegramStore()

const handleMessage = (event: MessageEvent) => {
  if (event.origin !== window.location.origin) return
  if (event.data?.type === 'telegram-auth' && event.data?.user) {
    telegramStore.handleBrowserAuth(event.data.user)
  }
}

const initTelegramWidget = () => {
  if (!loginWidget.value) return

  loginWidget.value.innerHTML = ''

  const script = document.createElement('script')
  script.src = 'https://telegram.org/js/telegram-widget.js?22'
  script.async = true
  script.setAttribute('data-telegram-login', import.meta.env.VITE_TELEGRAM_BOT_USERNAME || 'your_bot_username')
  script.setAttribute('data-size', 'large')
  script.setAttribute('data-radius', '10')
  script.setAttribute('data-auth-url', `${window.location.origin}/auth-callback.html`)
  script.setAttribute('data-request-access', 'write')

  loginWidget.value.appendChild(script)
}

onMounted(() => {
  window.addEventListener('message', handleMessage)

  setTimeout(() => {
    if (!telegramStore.isTelegramWebApp) {
      initTelegramWidget()
    }
  }, 100)
})

onUnmounted(() => {
  window.removeEventListener('message', handleMessage)
})
</script>

<style scoped>
.telegram-auth-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: hsl(var(--background));
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
}

.auth-content {
  text-align: center;
  padding: 2rem;
  max-width: 400px;
  width: 90%;
}

.auth-content h2 {
  margin-bottom: 1rem;
  color: hsl(var(--foreground));
}

.auth-content p {
  margin-bottom: 2rem;
  color: hsl(var(--foreground));
  opacity: 0.7;
}

#telegram-login-widget {
  display: flex;
  justify-content: center;
  margin-top: 1.5rem;
}
</style>
